import { type FC } from 'react'

import {
  RECOMMENDATION_SERVICE_CATEGORY,
  RECOMMENDATION_WIDGET_CATEGORY_NOVELTIES,
  useGetRecommendationWidgetId,
} from '../../../recommendation'
import { StoryblokRecommendationSliderRenderer } from '../StoryblokRecommendation/StoryblokRecommendationSliderRenderer'

type StoryblokAkeneoCategoryCrossSellPopularProductsSliderProps = {
  categoryCode: string
}

export const StoryblokAkeneoCategoryCrossSellPopularProductsSlider: FC<
  StoryblokAkeneoCategoryCrossSellPopularProductsSliderProps
> = ({ categoryCode }) => {
  const widgetId = useGetRecommendationWidgetId(
    RECOMMENDATION_SERVICE_CATEGORY,
    RECOMMENDATION_WIDGET_CATEGORY_NOVELTIES,
  )

  if (!widgetId) {
    return null
  }

  return (
    <StoryblokRecommendationSliderRenderer
      cid={categoryCode}
      serviceId={RECOMMENDATION_SERVICE_CATEGORY}
      widgetId={widgetId}
    />
  )
}
